import React from 'react';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import { Colors, Text } from 'library';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import { JobModel, PairingAppointmentModel } from '../NewsfeedModels';
import JobCardDetailRow from './JobCardDetailRow';

interface IAppliedJobCardDetailsProps {
    job: JobModel;
}

export default function GetDates({ job }: IAppliedJobCardDetailsProps) {
    const getWeeklyDays = () => {
        let days: string[] = job.date_times.reduce((daysArray: string[], day: PairingAppointmentModel) => {
            return [...daysArray, ...Object.keys(day)];
        }, []);

        let orderedDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return (
            <Grid container direction="row" spacing={3} style={styles.days}>
                {orderedDays.map((day) => (
                    <Grid
                        key={day}
                        container
                        justify="center"
                        alignItems="center"
                        style={days.includes(day) ? { ...styles.day, ...styles.selected } : styles.day}
                    >
                        <Text variant="body2" bold>
                            {day[0]}
                        </Text>
                    </Grid>
                ))}
            </Grid>
        );
    };

    const getOneTimeText = () => {
        let start = moment(job.start_date);
        let end = moment(job.end_date);
        let overnight = start.diff(end, 'days');
        return `${start.format('ddd, MMM D')}${overnight ? ' - ' + end.format('MMM D') : ''}`;
    };

    return (
        <>
            {job.ongoing ? (
                getWeeklyDays()
            ) : (
                <JobCardDetailRow
                    icon={<CalendarIcon color="primary" fontSize="small" />}
                    text={getOneTimeText()}
                    visible
                />
            )}
        </>
    );
}

const styles = {
    days: { margin: 12, marginLeft: 0 },
    day: {
        width: 25,
        height: 25,
        marginRight: 3,
    },
    selected: {
        backgroundColor: Colors.lightTurq,
        border: '1px solid rgb(0, 47, 77)',
        borderRadius: 13,
    },
};
